import { render, staticRenderFns } from "./MarketingSalesByMicroaudience.vue?vue&type=template&id=ffa53d80&"
import script from "./MarketingSalesByMicroaudience.vue?vue&type=script&lang=js&"
export * from "./MarketingSalesByMicroaudience.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports